import React, { useState } from 'react';

function LeadsForm() {
  const initialFormState = {
  primaryRole: '',

  fullName: '',
  email: '',
  phone: '',
  location: '',

  joiningAs: '',
  companyName: '',
  websiteOrLinkedin: '',

  professionalTitle: '',
  yearsExperience: '',
  professionalDescription: '',
  servicesOffered: [],
  servicesOfferedOther: '',
  willingToProvide: [],
  willingToProvideOther: '',
  portfolioLink: '',
  linkedinProfile: '',
  githubDribbbleBehance: '',

  businessType: '',
  industry: '',
  servicesNeeded: [],
  servicesNeededOther: '',
  projectDescription: '',
  budgetRange: '',
  timelineExpectation: '',

  operatingEmail: '',
  communicationMode: '',
  confirmAccuracy: false,
  agreePlatformCommunication: false,
  understandLoginCredentials: false
};

  const [formData, setFormData] = useState(initialFormState);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleMultiSelectChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: prev[name].includes(value)
        ? prev[name].filter(item => item !== value)
        : [...prev[name], value]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbwS1TSfmjTPZr6t0QF4K1WdOMvScCI1npwiieiskvlN-VaO2HInioalv6vbMYwADaVo/exec",
        {
          method: "POST",
          headers: {
            "Content-Type": "text/plain;charset=utf-8"
          },
          body: JSON.stringify(formData)
        }
      );

      alert("✅ Form submitted successfully!");
      setFormData(initialFormState);

    } catch (error) {
      console.error(error);
      alert("❌ Submission failed");
    }
  };

  const servicesOptions = [
    'Website Design',
    'Website Development',
    'Shopify Development',
    'WordPress Development',
    'Web Application Development',
    'Mobile App Development',
    'UI/UX Design',
    'Graphic Design',
    'Branding & Identity',
    'SEO',
    'Performance Marketing',
    'Social Media Management',
    'Content Writing',
    'Video Editing',
    'ERP / CRM Development',
    'Custom Software Development',
    'No-Code / Low-Code Solutions',
    'Maintenance & Support',
    'Other'
  ];

  const willingToProvideOptions = [
    'Fixed-Cost Projects',
    'Hourly Engagement',
    'Monthly Retainer',
    'Long-Term Collaboration',
    'White-Label Services',
    'Dedicated Resource',
    'Startup-Friendly Pricing',
    'MVP Development',
    'Consultation Only',
    'Post-Launch Support',
    'Other'
  ];

  const servicesNeededOptions = [
    'Website Design',
    'Website Development',
    'Shopify Store',
    'Landing Page',
    'Web Application',
    'Mobile App',
    'UI/UX Design',
    'Branding',
    'SEO',
    'Digital Marketing',
    'Social Media Management',
    'Content Writing',
    'Video Editing',
    'ERP / CRM',
    'Custom Software',
    'MVP Development',
    'Maintenance & Support',
    'Other'
  ];

  const inputStyle = {
    width: '100%',
    padding: '12px 16px',
    backgroundColor: '#404040',
    border: 'none',
    borderRadius: '6px',
    color: 'white',
    fontSize: '14px'
  };

  const labelStyle = {
    color: 'white',
    marginBottom: '8px',
    display: 'block',
    fontSize: '14px'
  };

  const sectionStyle = {
    marginBottom: '30px',
    paddingBottom: '20px',
    borderBottom: '1px solid #555'
  };

  return (
    <section className="leads-form-section" style={{
      backgroundColor: '#ffffff',
      minHeight: '100vh',
      padding: '100px 0 50px',
      color: 'white'
    }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
            <div className="leads-form-container" style={{
              backgroundColor: '#2a2a2a',
              padding: '40px',
              borderRadius: '10px'
            }}>
              <h2 style={{
                color: 'white',
                marginBottom: '30px',
                fontSize: '24px',
                fontWeight: '600'
              }}>
                Universal Registration Form
              </h2>

              <form onSubmit={handleSubmit}>
                {/* 1️⃣ Primary Role Selection */}
                <div style={sectionStyle}>
                  <h3 style={{ color: 'white', fontSize: '18px', marginBottom: '20px' }}>
                    1️⃣ Primary Role Selection
                  </h3>
                  <div className="form-group mb-4">
                    <label style={labelStyle}>
                      Who are you joining as? <span style={{ color: '#ff6b6b' }}>*</span>
                    </label>
                    <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                      <label style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                        <input
                          type="radio"
                          name="primaryRole"
                          value="service-provider"
                          checked={formData.primaryRole === 'service-provider'}
                          onChange={handleInputChange}
                          style={{ marginRight: '8px' }}
                        />
                        Service Provider (Freelancer / Agency)
                      </label>
                      <label style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                        <input
                          type="radio"
                          name="primaryRole"
                          value="service-taker"
                          checked={formData.primaryRole === 'service-taker'}
                          onChange={handleInputChange}
                          style={{ marginRight: '8px' }}
                        />
                        Service Taker (Client / Startup)
                      </label>
                    </div>
                  </div>
                </div>

                {/* 2️⃣ Basic Information */}
                {formData.primaryRole && (
                  <div style={sectionStyle}>
                    <h3 style={{ color: 'white', fontSize: '18px', marginBottom: '20px' }}>
                      2️⃣ Basic Information
                    </h3>

                    <div className="form-group mb-4">
                      <label style={labelStyle}>
                        Full Name <span style={{ color: '#ff6b6b' }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleInputChange}
                        required
                        style={inputStyle}
                      />
                    </div>

                    <div className="form-group mb-4">
                      <label style={labelStyle}>
                        Email Address <span style={{ color: '#ff6b6b' }}>*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        style={inputStyle}
                      />
                    </div>

                    <div className="form-group mb-4">
                      <label style={labelStyle}>
                        Phone Number <span style={{ color: '#ff6b6b' }}>*</span>
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        required
                        style={inputStyle}
                      />
                    </div>

                    <div className="form-group mb-4">
                      <label style={labelStyle}>
                        Country / City <span style={{ color: '#ff6b6b' }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="location"
                        value={formData.location}
                        onChange={handleInputChange}
                        required
                        style={inputStyle}
                      />
                    </div>
                  </div>
                )}

                {/* 3️⃣ Organization Details */}
                {formData.primaryRole && (
                  <div style={sectionStyle}>
                    <h3 style={{ color: 'white', fontSize: '18px', marginBottom: '20px' }}>
                      3️⃣ Organization Details
                    </h3>

                    <div className="form-group mb-4">
                      <label style={labelStyle}>
                        You are joining as <span style={{ color: '#ff6b6b' }}>*</span>
                      </label>
                      <select
                        name="joiningAs"
                        value={formData.joiningAs}
                        onChange={handleInputChange}
                        required
                        style={inputStyle}
                      >
                        <option value="">Select...</option>
                        <option value="individual">Individual</option>
                        <option value="company">Company / Agency</option>
                      </select>
                    </div>

                    {formData.joiningAs === 'company' && (
                      <>
                        <div className="form-group mb-4">
                          <label style={labelStyle}>
                            Company / Agency Name <span style={{ color: '#ff6b6b' }}>*</span>
                          </label>
                          <input
                            type="text"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleInputChange}
                            required
                            style={inputStyle}
                          />
                        </div>

                        <div className="form-group mb-4">
                          <label style={labelStyle}>
                            Website or LinkedIn Profile <span style={{ color: '#ff6b6b' }}>*</span>
                          </label>
                          <input
                            type="url"
                            name="websiteOrLinkedin"
                            value={formData.websiteOrLinkedin}
                            onChange={handleInputChange}
                            required
                            style={inputStyle}
                          />
                        </div>
                      </>
                    )}
                  </div>
                )}

                {/* 🔹 SERVICE PROVIDER SECTIONS */}
                {formData.primaryRole === 'service-provider' && (
                  <>
                    {/* 4️⃣ Professional Profile */}
                    <div style={sectionStyle}>
                      <h3 style={{ color: 'white', fontSize: '18px', marginBottom: '20px' }}>
                        4️⃣ Professional Profile
                      </h3>

                      <div className="form-group mb-4">
                        <label style={labelStyle}>
                          Primary Role / Title <span style={{ color: '#ff6b6b' }}>*</span>
                        </label>
                        <input
                          type="text"
                          name="professionalTitle"
                          placeholder="Example: Web Developer, UI/UX Designer, Digital Marketer"
                          value={formData.professionalTitle}
                          onChange={handleInputChange}
                          required
                          style={inputStyle}
                        />
                      </div>

                      <div className="form-group mb-4">
                        <label style={labelStyle}>
                          Years of Experience <span style={{ color: '#ff6b6b' }}>*</span>
                        </label>
                        <select
                          name="yearsExperience"
                          value={formData.yearsExperience}
                          onChange={handleInputChange}
                          required
                          style={inputStyle}
                        >
                          <option value="">Select...</option>
                          <option value="0-1">0-1 years</option>
                          <option value="1-3">1-3 years</option>
                          <option value="3-5">3-5 years</option>
                          <option value="5-10">5-10 years</option>
                          <option value="10+">10+ years</option>
                        </select>
                      </div>

                      <div className="form-group mb-4">
                        <label style={labelStyle}>
                          Short Professional Description (Min 100 words) <span style={{ color: '#ff6b6b' }}>*</span>
                        </label>
                        <textarea
                          name="professionalDescription"
                          value={formData.professionalDescription}
                          onChange={handleInputChange}
                          required
                          rows="4"
                          style={inputStyle}
                        />
                      </div>
                    </div>

                    {/* 5️⃣ Services You Offer */}
                    <div style={sectionStyle}>
                      <h3 style={{ color: 'white', fontSize: '18px', marginBottom: '20px' }}>
                        5️⃣ Services You Offer
                      </h3>

                      <div className="form-group mb-4">
                        <label style={labelStyle}>
                          Select Services (Multi-Select) <span style={{ color: '#ff6b6b' }}>*</span>
                        </label>
                        <div style={{
                          maxHeight: '200px',
                          overflowY: 'auto',
                          border: '1px solid #555',
                          borderRadius: '6px',
                          padding: '10px',
                          backgroundColor: '#404040'
                        }}>
                          {servicesOptions.map(service => (
                            <label key={service} style={{
                              display: 'flex',
                              alignItems: 'center',
                              color: 'white',
                              marginBottom: '8px',
                              cursor: 'pointer'
                            }}>
                              <input
                                type="checkbox"
                                checked={formData.servicesOffered.includes(service)}
                                onChange={() => handleMultiSelectChange('servicesOffered', service)}
                                style={{ marginRight: '8px' }}
                              />
                              {service}
                            </label>
                          ))}
                        </div>

                        {formData.servicesOffered.includes('Other') && (
                          <input
                            type="text"
                            name="servicesOfferedOther"
                            placeholder="Please specify other services"
                            value={formData.servicesOfferedOther}
                            onChange={handleInputChange}
                            style={{ ...inputStyle, marginTop: '10px' }}
                          />
                        )}
                      </div>
                    </div>

                    {/* 6️⃣ What You Are Willing to Provide */}
                    <div style={sectionStyle}>
                      <h3 style={{ color: 'white', fontSize: '18px', marginBottom: '20px' }}>
                        6️⃣ What You Are Willing to Provide
                      </h3>

                      <div className="form-group mb-4">
                        <label style={labelStyle}>
                          Select Options (Multi-Select) <span style={{ color: '#ff6b6b' }}>*</span>
                        </label>
                        <div style={{
                          maxHeight: '200px',
                          overflowY: 'auto',
                          border: '1px solid #555',
                          borderRadius: '6px',
                          padding: '10px',
                          backgroundColor: '#404040'
                        }}>
                          {willingToProvideOptions.map(option => (
                            <label key={option} style={{
                              display: 'flex',
                              alignItems: 'center',
                              color: 'white',
                              marginBottom: '8px',
                              cursor: 'pointer'
                            }}>
                              <input
                                type="checkbox"
                                checked={formData.willingToProvide.includes(option)}
                                onChange={() => handleMultiSelectChange('willingToProvide', option)}
                                style={{ marginRight: '8px' }}
                              />
                              {option}
                            </label>
                          ))}
                        </div>

                        {formData.willingToProvide.includes('Other') && (
                          <input
                            type="text"
                            name="willingToProvideOther"
                            placeholder="Please specify other options"
                            value={formData.willingToProvideOther}
                            onChange={handleInputChange}
                            style={{ ...inputStyle, marginTop: '10px' }}
                          />
                        )}
                      </div>
                    </div>

                    {/* 7️⃣ Portfolio & Proof */}
                    <div style={sectionStyle}>
                      <h3 style={{ color: 'white', fontSize: '18px', marginBottom: '20px' }}>
                        7️⃣ Portfolio & Proof
                      </h3>

                      <div className="form-group mb-4">
                        <label style={labelStyle}>
                          Portfolio / Website Link <span style={{ color: '#ff6b6b' }}>*</span>
                        </label>
                        <input
                          type="url"
                          name="portfolioLink"
                          value={formData.portfolioLink}
                          onChange={handleInputChange}
                          required
                          style={inputStyle}
                        />
                      </div>

                      <div className="form-group mb-4">
                        <label style={labelStyle}>
                          LinkedIn Profile <span style={{ color: '#ff6b6b' }}>*</span>
                        </label>
                        <input
                          type="url"
                          name="linkedinProfile"
                          value={formData.linkedinProfile}
                          onChange={handleInputChange}
                          required
                          style={inputStyle}
                        />
                      </div>

                      <div className="form-group mb-4">
                        <label style={labelStyle}>
                          GitHub / Dribbble / Behance (Optional)
                        </label>
                        <input
                          type="url"
                          name="githubDribbbleBehance"
                          value={formData.githubDribbbleBehance}
                          onChange={handleInputChange}
                          style={inputStyle}
                        />
                      </div>
                    </div>
                  </>
                )}

                {/* 🔹 SERVICE TAKER SECTIONS */}
                {formData.primaryRole === 'service-taker' && (
                  <>
                    {/* 4️⃣ Business / Project Overview */}
                    <div style={sectionStyle}>
                      <h3 style={{ color: 'white', fontSize: '18px', marginBottom: '20px' }}>
                        4️⃣ Business / Project Overview
                      </h3>

                      <div className="form-group mb-4">
                        <label style={labelStyle}>
                          Business Type <span style={{ color: '#ff6b6b' }}>*</span>
                        </label>
                        <select
                          name="businessType"
                          value={formData.businessType}
                          onChange={handleInputChange}
                          required
                          style={inputStyle}
                        >
                          <option value="">Select...</option>
                          <option value="startup">Startup</option>
                          <option value="small-business">Small Business</option>
                          <option value="enterprise">Enterprise</option>
                          <option value="individual">Individual</option>
                        </select>
                      </div>

                      <div className="form-group mb-4">
                        <label style={labelStyle}>
                          Industry <span style={{ color: '#ff6b6b' }}>*</span>
                        </label>
                        <input
                          type="text"
                          name="industry"
                          value={formData.industry}
                          onChange={handleInputChange}
                          required
                          style={inputStyle}
                        />
                      </div>

                      <div className="form-group mb-4">
                        <label style={labelStyle}>
                          Website or LinkedIn Profile
                        </label>
                        <input
                          type="url"
                          name="websiteOrLinkedin"
                          value={formData.websiteOrLinkedin}
                          onChange={handleInputChange}
                          style={inputStyle}
                        />
                      </div>
                    </div>

                    {/* 5️⃣ What Do You Need? */}
                    <div style={sectionStyle}>
                      <h3 style={{ color: 'white', fontSize: '18px', marginBottom: '20px' }}>
                        5️⃣ What Do You Need?
                      </h3>

                      <div className="form-group mb-4">
                        <label style={labelStyle}>
                          Select Services Needed (Multi-Select) <span style={{ color: '#ff6b6b' }}>*</span>
                        </label>
                        <div style={{
                          maxHeight: '200px',
                          overflowY: 'auto',
                          border: '1px solid #555',
                          borderRadius: '6px',
                          padding: '10px',
                          backgroundColor: '#404040'
                        }}>
                          {servicesNeededOptions.map(service => (
                            <label key={service} style={{
                              display: 'flex',
                              alignItems: 'center',
                              color: 'white',
                              marginBottom: '8px',
                              cursor: 'pointer'
                            }}>
                              <input
                                type="checkbox"
                                checked={formData.servicesNeeded.includes(service)}
                                onChange={() => handleMultiSelectChange('servicesNeeded', service)}
                                style={{ marginRight: '8px' }}
                              />
                              {service}
                            </label>
                          ))}
                        </div>

                        {formData.servicesNeeded.includes('Other') && (
                          <input
                            type="text"
                            name="servicesNeededOther"
                            placeholder="Please specify other services needed"
                            value={formData.servicesNeededOther}
                            onChange={handleInputChange}
                            style={{ ...inputStyle, marginTop: '10px' }}
                          />
                        )}
                      </div>
                    </div>

                    {/* 6️⃣ Project Description */}
                    <div style={sectionStyle}>
                      <h3 style={{ color: 'white', fontSize: '18px', marginBottom: '20px' }}>
                        6️⃣ Project Description
                      </h3>

                      <div className="form-group mb-4">
                        <label style={labelStyle}>
                          Describe your requirement (Min 100 words) <span style={{ color: '#ff6b6b' }}>*</span>
                        </label>
                        <p style={{ color: '#ccc', fontSize: '12px', marginBottom: '8px' }}>
                          Please include: Problem you want solved, Scope of work, Expectations
                        </p>
                        <textarea
                          name="projectDescription"
                          value={formData.projectDescription}
                          onChange={handleInputChange}
                          required
                          rows="5"
                          style={inputStyle}
                        />
                      </div>
                    </div>

                    {/* 7️⃣ Budget Range */}
                    <div style={sectionStyle}>
                      <h3 style={{ color: 'white', fontSize: '18px', marginBottom: '20px' }}>
                        7️⃣ Budget Range
                      </h3>

                      <div className="form-group mb-4">
                        <label style={labelStyle}>
                          Budget Range <span style={{ color: '#ff6b6b' }}>*</span>
                        </label>
                        <select
                          name="budgetRange"
                          value={formData.budgetRange}
                          onChange={handleInputChange}
                          required
                          style={inputStyle}
                        >
                          <option value="">Select...</option>
                          <option value="under-10k">Under ₹10,000</option>
                          <option value="10k-25k">₹10,000 – ₹25,000</option>
                          <option value="25k-50k">₹25,000 – ₹50,000</option>
                          <option value="50k-100k">₹50,000 – ₹1,00,000</option>
                          <option value="100k+">₹1,00,000+</option>
                          <option value="not-decided">Not Decided Yet</option>
                        </select>
                      </div>
                    </div>

                    {/* 8️⃣ Timeline Expectation */}
                    <div style={sectionStyle}>
                      <h3 style={{ color: 'white', fontSize: '18px', marginBottom: '20px' }}>
                        8️⃣ Timeline Expectation
                      </h3>

                      <div className="form-group mb-4">
                        <label style={labelStyle}>
                          Timeline Expectation <span style={{ color: '#ff6b6b' }}>*</span>
                        </label>
                        <select
                          name="timelineExpectation"
                          value={formData.timelineExpectation}
                          onChange={handleInputChange}
                          required
                          style={inputStyle}
                        >
                          <option value="">Select...</option>
                          <option value="asap">ASAP</option>
                          <option value="1-2-weeks">1–2 Weeks</option>
                          <option value="1-month">1 Month</option>
                          <option value="2-3-months">2–3 Months</option>
                          <option value="flexible">Flexible</option>
                        </select>
                      </div>
                    </div>
                  </>
                )}

                {/* 9️⃣ Common Final Section */}
                {formData.primaryRole && (
                  <div style={sectionStyle}>
                    <h3 style={{ color: 'white', fontSize: '18px', marginBottom: '20px' }}>
                      9️⃣ Account & Communication
                    </h3>

                    <div className="form-group mb-4">
                      <label style={labelStyle}>
                        Email to operate the account <span style={{ color: '#ff6b6b' }}>*</span>
                      </label>
                      <input
                        type="email"
                        name="operatingEmail"
                        value={formData.operatingEmail}
                        onChange={handleInputChange}
                        required
                        style={inputStyle}
                      />
                    </div>

                    <div className="form-group mb-4">
                      <label style={labelStyle}>
                        Preferred Communication Mode <span style={{ color: '#ff6b6b' }}>*</span>
                      </label>
                      <select
                        name="communicationMode"
                        value={formData.communicationMode}
                        onChange={handleInputChange}
                        required
                        style={inputStyle}
                      >
                        <option value="">Select...</option>
                        <option value="email">Email</option>
                        <option value="whatsapp">WhatsApp</option>
                        <option value="platform-chat">Platform Chat</option>
                      </select>
                    </div>

                    {/* Confirmation Checkboxes */}
                    <div className="form-group mb-4">
                      <label style={{
                        color: 'white',
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontSize: '14px',
                        lineHeight: '1.5',
                        marginBottom: '10px'
                      }}>
                        <input
                          type="checkbox"
                          name="confirmAccuracy"
                          checked={formData.confirmAccuracy}
                          onChange={handleInputChange}
                          required
                          style={{ marginRight: '10px', marginTop: '2px' }}
                        />
                        I confirm the information provided is accurate <span style={{ color: '#ff6b6b' }}>*</span>
                      </label>

                      <label style={{
                        color: 'white',
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontSize: '14px',
                        lineHeight: '1.5',
                        marginBottom: '10px'
                      }}>
                        <input
                          type="checkbox"
                          name="agreePlatformCommunication"
                          checked={formData.agreePlatformCommunication}
                          onChange={handleInputChange}
                          required
                          style={{ marginRight: '10px', marginTop: '2px' }}
                        />
                        I agree to receive platform communication <span style={{ color: '#ff6b6b' }}>*</span>
                      </label>

                      <label style={{
                        color: 'white',
                        display: 'flex',
                        alignItems: 'flex-start',
                        fontSize: '14px',
                        lineHeight: '1.5'
                      }}>
                        <input
                          type="checkbox"
                          name="understandLoginCredentials"
                          checked={formData.understandLoginCredentials}
                          onChange={handleInputChange}
                          required
                          style={{ marginRight: '10px', marginTop: '2px' }}
                        />
                        I understand I will receive login credentials via email <span style={{ color: '#ff6b6b' }}>*</span>
                      </label>
                    </div>
                  </div>
                )}

                {/* Submit Button */}
                {formData.primaryRole && (
                  <button
                    type="submit"
                    style={{
                      width: '100%',
                      padding: '15px',
                      backgroundColor: 'white',
                      color: '#2a2a2a',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: 'pointer',
                      marginTop: '20px'
                    }}
                  >
                    Submit
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LeadsForm;